export default __webpack_public_path__ + "static/media/user_guide2.072fcee7.png";